import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { BotControllerApi } from 'api/controllers/bot-controller-api';
import { QueryKeys } from 'utils/queryKeys';

export const useApi = () => {
  const { dayDate } = useParams<{ dayDate: string }>();

  const getMenu = useQuery(
    [QueryKeys.GET_MENU_BY_DAY, dayDate],
    () => BotControllerApi.getMenu_next({ dayDate: dayDate as string }),
    { enabled: !!dayDate },
  );

  return { getMenu };
};
